module.exports = __webpack_public_path__ + "static/images/common-3.8bfde48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/common-3.png
// module id = Mjp8
// module chunks = 8